import { Alert, Link } from '@zopauk/react-components';
import { useServerExperiment } from '@zopauk/nextjs-amplitude-experiment/client';

type Payload =
  | {
      linkHref?: string;
      linkText?: string;
      body?: string;
    }
  | undefined;

export const InvestorsP2PClosureBanner = () => {
  const experimentsQuery = useServerExperiment(['web-platform-hub-investors-info']);

  if (experimentsQuery.data) {
    const payload = experimentsQuery.data['web-platform-hub-investors-info']?.payload as Payload;

    return payload?.body ? (
      <Alert data-automation="ZA.investors-p2p-closure-banner" severity="warning" hasRoundedCorners className="mb-4">
        {payload?.body}{' '}
        {payload?.linkHref ? (
          <Link href={payload.linkHref} type="email">
            {payload?.linkText || 'Find out more'}
          </Link>
        ) : null}
      </Alert>
    ) : null;
  }

  return null;
};
